import { generateKeys } from '../utils';
export const broadcastableEvents = generateKeys({
    clientDepositFailed: {},
    clientCreatedOwnDocument: {},
    clientAppropriateTestDone: {},
    clientDocsApproved: {},
    clientSignedUp: {},
    clientOpenedAccount: {},
    clientCampaignSubcampaign: {},
    clientAssignedTestGroup: {},
    clientMadeDeposit: {},
    clientWithdrawalRequestSent: {},
    clientWithdrawalRequestApproved: {},
    clientWithdrawalMade: {},
    acceptedBonusMade: {},
    leadCreated: {},
    documentForAutoVerification: {},
    clientLoggedIn: {},
    clientChangedDetails: {},
    processWithdrawal: {},
});
export const socketEvents = generateKeys({
    unsubscribe: {
        value: 'unsubscribe',
    },
    subscribe: {
        value: 'subscribe',
    },
    online: {
        value: 'online',
    },
    offline: {
        value: 'offline',
    },
    disconnect: {
        value: 'disconnect',
    },
    clientOnline: {
        value: 'clientOnline',
    },
    clientOffline: {
        value: 'clientOffline',
    },
    userOnline: {
        value: 'userOnline',
    },
    userOffline: {
        value: 'userOffline',
    },
    newDeposit: {
        value: 'newDeposit',
    },
    attemptedDeposit: {
        value: 'attemptedDeposit',
    },
    newClient: {
        value: 'newClient',
    },
    newUser: {
        value: 'newUser',
    },
    newWithdrawal: {
        value: 'newWithdrawal',
    },
    newNews: {
        value: 'newNews',
    },
    newDocument: {
        value: 'newDocument',
    },
    binaryFirstDeposit: {
        value: 'binaryFirstDeposit',
    },
    callAnnotationRequest: {
        value: 'callAnnotationRequest',
    },
    refresh: {
        value: 'refresh',
    },
    join: {
        value: 'join',
    },
    leave: {
        value: 'leave',
    },
    newLeadAssigned: {
        value: 'newLeadAssigned',
    },
    electronicIdVerification: {
        value: 'electronicIdVerification',
    },
    appointmentNotification: {
        value: 'appointmentNotification',
    },
    dismissAppointmentNotification: {
        value: 'dismissAppointmentNotification',
    },
    userUpdated: {
        value: 'userUpdated',
    },
    ticketCreated: {
        value: 'ticketCreated',
    },
    newPartnershipAccount: {
        value: 'newPartnershipAccount',
    },
});
export const scheduledNotificationTypes = generateKeys({
    ftdKYCNoticeFirstStage: {
        value: 'ftdKYCNoticeFirstStage',
    },
    ftdKYCNoticeSecondStage: {
        value: 'ftdKYCNoticeSecondStage',
    },
    ftdKYCNoticeThirdStage: {
        value: 'ftdKYCNoticeThirdStage',
    },
    kycGracePeriodOver: {
        value: 'kycGracePeriodOver',
    },
    checkWorldCheckResults: {
        value: 'checkWorldCheckResults',
    },
    affiliateRegistrationEmailOneDay: {
        value: 'affiliateRegistrationEmailOneDay',
    },
    affiliateRegistrationEmailSevenDays: {
        value: 'affiliateRegistrationEmailSevenDays',
    },
    kycGracePeriodOverFirstReminder: {
        value: 'kycGracePeriodOverFirstReminder',
    },
    kycGracePeriodOverSecondReminder: {
        value: 'kycGracePeriodOverSecondReminder',
    },
    kycGracePeriodOverCloseAccount: {
        value: 'kycGracePeriodOverCloseAccount',
    },
    threeCreditCardsFirstReminder: {
        value: 'threeCreditCardsFirstReminder',
    },
    threeCreditCardsSecondReminder: {
        value: 'threeCreditCardsSecondReminder',
    },
    threeCreditCardsFinalCheck: {
        value: 'threeCreditCardsFinalCheck',
    },
    heldDepositReminder: {
        value: 'heldDepositReminder',
    },
});
export const tradingEvents = generateKeys({
    marginCall: {
        value: 'marginCall',
    },
});
